import { BACKEND_API_URI } from '../auth/msalConfig';
import { BaseService } from './baseService';

export class BackendHttpService extends BaseService {
  constructor(endpoint: string) {
    super(BACKEND_API_URI, endpoint);
  }
} 
